import React, { useRef, useState } from 'react';

import { Logout } from '@mui/icons-material';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import {
  Box,
  Button,
  Divider,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Tooltip,
} from '@mui/material';

import { useAuth } from '@client/context/auth/AuthContext';
import { userMenu } from '@constants/navigation';
import errorHandler from '@server/logger/errorHandler';

import { colors } from '@app/frontend/lib/theme/colors';

import { ProfileAvatar } from './ProfileAvatar';
import { UserMenuItem } from './UserMenuItem';

const UserAvatarMenu = (props: {
  onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
}) => {
  const { profile, admin } = userMenu;
  const { logOut, user } = useAuth();
  const buttonRef = useRef(null);

  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);

  const closeMenu = () => setIsProfileMenuOpen(false);

  const handleLogOut = async () => {
    try {
      await logOut();
    } catch (error: any) {
      errorHandler({ error });
    }
  };

  return (
    <>
      <Box component='div' sx={{ marginTop: 'auto' }}>
        <Divider sx={{ borderColor: colors.component.paperBorderColor }} />
        <Box component='div' sx={{ display: 'flex', px: 1.5, py: 0.5 }}>
          <Tooltip title='Account settings' placement='top'>
            <Button
              sx={{ minHeight: 0, minWidth: 0, padding: 0 }}
              fullWidth
              disableRipple={true}
              onClick={() => setIsProfileMenuOpen(!isProfileMenuOpen)}
              ref={buttonRef}>
              <ProfileAvatar name={user?.displayName ?? ''} email={user?.email ?? ''} />
            </Button>
          </Tooltip>
        </Box>
      </Box>

      <Menu
        open={isProfileMenuOpen}
        anchorEl={buttonRef.current}
        onClose={closeMenu}
        onClick={closeMenu}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'right',
        }}
        id='account-menu'>
        <UserMenuItem
          name={profile.name}
          path={profile.path}
          icon={<AccountCircleOutlinedIcon />}
        />
        {user?.email?.includes('test@astro.tax') && (
          <UserMenuItem name={admin.name} path={admin.path} icon={<AccountCircleOutlinedIcon />} />
        )}
        <Divider />
        <MenuItem onClick={handleLogOut}>
          <ListItemIcon>{<Logout />}</ListItemIcon>
          <ListItemText primary={'Afmelden'} />
        </MenuItem>
      </Menu>
    </>
  );
};

export default UserAvatarMenu;
